package com.bikompanion.ui.composables

import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.bikompanion.ui.preview.PreviewSurface
import com.bikompanion.ui.strings.LocalStrings

/**
 * Says the racks are on their way, for the moments where that is not instant.
 *
 * Racks come from the dataset shipped with the app, so this is usually a flicker. It still earns
 * its place: the first look of a session opens a 5.5 MB file, and the fallback path — a build
 * whose dataset will not open — is a network request. Without it the map sits empty, and the
 * obvious reading of an empty map is that there is nowhere here to lock a bike.
 */
@Composable
internal fun ParkingLoadingIndicator(
    isLoading: Boolean,
    modifier: Modifier = Modifier,
) {
    if (!isLoading) return
    LoadingPill(text = LocalStrings.current.parkingLoading, modifier = modifier)
}

@Preview
@Composable
private fun ParkingLoadingIndicatorPreview() {
    PreviewSurface {
        ParkingLoadingIndicator(isLoading = true, modifier = Modifier.padding(16.dp))
    }
}

@Preview
@Composable
private fun ParkingLoadingIndicatorHiddenPreview() {
    PreviewSurface {
        ParkingLoadingIndicator(isLoading = false, modifier = Modifier.padding(16.dp))
    }
}
